import content from "../content/content.json";

export const getMenuItems = () => content.menuItems;
export const getSections = () => content.sections;

export const getInfoBarDescriptorFirstAppeareance = (sectionNumber) => {
  return content.sections[sectionNumber].content
    .infoBarDescriptorFirstAppearance;
};

export const getPrevSectionContentIndex = (position, length) => {
  if (position === 1) return length - 1;
  else return position - 1;
};

export const getNextSectionContentIndex = (position, length) => {
  if (position === length - 1) return 1;
  else return position + 1;
};

export function getDownloadCenter() {
  return content.downloadCenter;
}
